<template>
  <q-btn
    v-if="isGranted('DELETE_SOCIAL_ACCOUNT')"
    icon="fa fa-times"
    label="Delete Social Account"
    color="red-1"
    text-color="dark"
    unelevated
    rounded
    no-caps
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SocialAccount } from '@/type';
import openModal from '@/components/modal';
import isGranted from '@/auth/isGranted';
import DeleteAccountModal from './DeleteAccountModal.vue';

export default defineComponent({
  props: {
    socialAccount: {
      type: Object as () => SocialAccount,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = {
        parent: this,
        socialAccount: this.socialAccount,
      };
      openModal(DeleteAccountModal, props);
    },
    isGranted,
  },
});
</script>
